import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useStyles } from "./exam-paper-selection.style";
import { ExamPaperSelectionItem, useExamPaperSelection } from "./use-exam-paper-selection.hook";
import Loading from "src/app/modules/Recruitment/components/loading/loading";
import Empty from "src/app/modules/Recruitment/components/empty/empty";
import { useTranslation } from "@pruforce/common-adminweb-sdk";

export interface ExamPaperSelectionStepProps {
  value: string;
  onChange: (paper: ExamPaperSelectionItem) => void;
}

export const ExamPaperSelectionStep = (props: ExamPaperSelectionStepProps) => {
  const t = useTranslation();
  const { value, onChange } = props;
  const { classes, cx } = useStyles();
  const { paperList, loading } = useExamPaperSelection();

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={classes.container}>
      <Typography component="p" className={classes.descriptionText}>
        {t("recruitment.exam.registration.adminRegistration.examPaperSelection.topDescription")}
      </Typography>
      {paperList.length === 0 ? (
        <Empty />
      ) : (
        <RadioGroup
          value={value}
          className={classes.paperGroup}
          aria-label="exam paper selection"
        >
          {paperList.map((paper, i) => {
            const selected = value === paper.value;
            return (
              <FormControlLabel
                key={`${paper.value}-${i}`}
                value={paper.value}
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    checked={selected}
                    onChange={() => onChange(paper)}
                  />
                }
                label={paper.localized}
                className={cx(classes.paperOption, selected && classes.paperOptionSelected)}
                classes={{ label: classes.paperOptionLabel }}
              />
            );
          })}
        </RadioGroup>
      )}
    </div>
  );
};
